import React from "react";
import Modal from "react-bootstrap/Modal";
import { UnassociatedCampainTable } from "./UnassociatedCampainTable";
const UnassociatedCampainModal = ({
  showUnassociatedCampainModal,
  setShowUnassociatedCampainModal,
  campaignList,
}) => {
  function handleClose() {
    setShowUnassociatedCampainModal(false);
  }

  return (
  
      <Modal
        show={showUnassociatedCampainModal}
        onHide={handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered // This centers the modal vertically in the viewport
      >
        <Modal.Header>
          <div className="d-flex flex-column gap-1 w-100">
            <div className="d-flex justify-content-between align-items-center"> 
              <span className="fs-4 fw-bold">
                Available Google Ads Campaign
              </span>
              <button className="btn-close" onClick={handleClose}></button>
            </div>
            <small className="fs-8">
              Explore the list of active campaigns available under your Google Ads account.
            </small>
          </div>
        </Modal.Header>
        <Modal.Body className="overflow-auto" style={{ height: "50vh" }}>
          <UnassociatedCampainTable
            campaignList={campaignList}
            setShowUnassociatedCampainModal={setShowUnassociatedCampainModal}
          />
        </Modal.Body>
      </Modal>
    
  );
};

export default UnassociatedCampainModal;
